import { parse } from "@brillout/json-serializer/parse";

export function getPageContextSerializedInHtml() {
	// elem should exist because:
	// 1. <script id="vike_pageContext" type="application/json"> appears before the <script> that loads Vike's client runtime (which includes this file)
	// 2. <script id="vike_pageContext" type="application/json"> is neither async nor defer
	// See https://github.com/vikejs/vike/pull/1271
	const id = 'vike_pageContext';
	const elem = document.getElementById(id);
	if (elem === null) {return {};}
	const pageContextJson = elem.textContent;
	if (pageContextJson === null) {return {};}
	return parse(pageContextJson);
}
